module.exports = __webpack_public_path__ + "img/Message.b094001a.png";